export const manifest = {
  screens: {
    scr_gg225t: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_8oimaa: { name: "Pricing", route: "/pricing", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_hsz4l1: { name: "Marketing pages", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_hsz4l1", children: [
      { kind: "screen", id: "scr_gg225t" },
      { kind: "screen", id: "scr_8oimaa" },
    ] },
  ],
}
